import {
  ALL_PARTITIONS,
  MAX_PARTITIONS,
  parsePartitions,
  partitionLabel,
} from '../auditRetention.logic';

export function ReferenceField({
  id,
  label,
  value,
  onChange,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div>
      <label className="label" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className="input w-full font-mono"
        autoComplete="off"
        placeholder="DM-1234"
        value={value}
        onChange={event => onChange(event.target.value)}
      />
    </div>
  );
}

export function PartitionsField({
  id,
  label,
  value,
  onChange,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const parsedCount = parsePartitions(value).length;
  return (
    <div>
      <label className="label" htmlFor={id}>
        {label}
      </label>
      <textarea
        id={id}
        className="input w-full min-h-[80px] font-mono"
        placeholder="audit_events_p2026_01, audit_events_p2026_02"
        value={value}
        onChange={event => onChange(event.target.value)}
      />
      <p className="text-xs text-gray-text mt-1">
        Comma or newline separated, up to {MAX_PARTITIONS}. {ALL_PARTITIONS} holds every partition.
        {parsedCount > 0 && ` ${parsedCount} listed.`}
      </p>
    </div>
  );
}

export function PartitionList({ partitions }: { partitions: readonly string[] }) {
  if (partitions.length === 0) return <p className="text-sm text-gray-text">—</p>;
  return (
    <ul className="space-y-1">
      {partitions.map(partition => (
        <li key={partition} className="font-mono text-sm text-white break-all">
          {partitionLabel(partition)}
        </li>
      ))}
    </ul>
  );
}

export function BlockerHint({ blocker }: { blocker: string | null }) {
  return (
    <p className="text-xs text-yellow-400 min-h-[1rem]" aria-live="polite">
      {blocker}
    </p>
  );
}

export function monoValue(value: string | null) {
  return value === null ? null : <span className="font-mono text-xs break-all">{value}</span>;
}
